<template>
    <QNavigation v-bind="navigationConfig" @click="onNavClick" v-if="showNav" :scrollTarget="scrollTarget" @change="onNavChange"> </QNavigation>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted, nextTick, provide, watch } from 'vue';
import { QNavigation } from '@q-front-npm/h5-ui';
import { getNavHeight, setWebviewConfig, closeWebview, jsbSupportMap, jsbStorage, openShareTab, fusionReport } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@common/store/common';
import { useStore } from '@/store';
import { assign } from 'radash';
const storeCommon = useStoreCommon();
const store = useStore();
const showNav = jsbSupportMap.app.fullScreenThree && storeCommon.urlParams.full_screen === '3' && !storeCommon.inTopTab;

const props = withDefaults(
    defineProps<{
        config?: Record<string, any>;
        isCloseWebiew?: boolean;
        scrollTarget?: HTMLElement;
    }>(),
    {
        config: () => ({}),
        isCloseWebiew: true,
    }
);

const defaultConfig = {
    statusHeight: '36',
    fullScreen: true,
    maxWidth: `${Math.round(storeCommon.appMaxWidth)}`,
    navPadding: 0,
    beginBufferNumber: 1,
    endBufferRatio: 1,
    title: '九天揽月纪·诗酒剑仙途',
    size: 'middle',
    menuConfig: {
        left: showNav
            ? [
                {
                    icon: '&#xe660;',
                    type: 'back',
                    title: '',
                    data: {},
                }
            ]
            : [],
        right: [],
    },
    styleConfig: {
        default: {
            text: {
                color: '#fff',
                opacity: 1,
            },
            title: {
                color: '#fff',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'white',
        },
        fixed: {
            text: {
                color: '#111',
                opacity: 1,
            },
            title: {
                color: '#111',
                opacity: 1,
            },
            bg: {
                background: '#fff',
            },
            statusBar: 'black',
        },
    },
};
const navigationConfig = ref<Record<string, any>>(assign(defaultConfig, props.config));

const getStatusBarInfo = async() => {
    try {
        let statusBarH = await jsbStorage.get('statusBarH', 'activityCommon');
        let navConfig: Record<string, any> = {};
        if (!statusBarH) {
            navConfig = await getNavHeight();
            statusBarH = navConfig.statusBarH;
        }
        navigationConfig.value.statusHeight = statusBarH;
        storeCommon.headerHeight = +statusBarH + 52;
        setWebviewConfig({ status_bar: navigationConfig.value.styleConfig.default.statusBar, });
        jsbStorage.set('statusBarH', statusBarH, 'activityCommon');
    } catch (e) {
        storeCommon.headerHeight = 80;
    }
    emit('initFinish');
};
const emit = defineEmits(['navClick', 'initFinish']);
watch(
    () => storeCommon.appMaxWidth,
    () => {
        onUpdate({
            maxWidth: `${Math.round(storeCommon.appMaxWidth)}`,
        });
    }
);
const onNavClick = (e: Record<string, any>) => {
    emit('navClick', e);
    if (props.isCloseWebiew && e.type === 'back') {
        closeWebview();
    }
};

const onNavChange = async(data: Record<string, any>) => {
    if (data.type === 'animation') {
        setWebviewConfig({ status_bar: navigationConfig.value.styleConfig[data.value].statusBar, });
    }
};

if (storeCommon.systemInfo.inQmApp) {
    getStatusBarInfo();
}

const onUpdate = (config: Record<string, any>) => {
    navigationConfig.value = assign(navigationConfig.value, config);
};

defineExpose({
    onUpdate,
});

onMounted(() => {});
</script>

<style lang="scss" scoped>
:deep(.q-navigation-nav .btn.icon .iconfont-icon) {
    font-size: 44px;
}
</style>
